module.exports = __webpack_public_path__ + "img/vegan.6c3f03b9.jpg";